import PhotoEditor from "@/editor/editor";
import { EditorOpsZod } from "@/editor/editorCore";
import { useAppContext } from "@/state/appContext";
import { fotoURL } from "@/helpers/foto";
import { router } from "@/main";
import { POST, urlToDataUrl } from "@/state/api";
import { queryClient } from "@/state/server";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_app/editor")({
  component: RouteComponent,
  validateSearch: z.object({
    pedido_id: z.coerce.number(),
    foto_id: z.coerce.number(),
  }),
});

function RouteComponent() {
  const { pedido_id, foto_id } = Route.useSearch();
  const {
    state: { usuario },
  } = useAppContext();

  const pedido = usuario.pedidos[pedido_id];

  if (!pedido) return "Pedido inválido";
  if (pedido.pagado) return "El pedido ya fue cerrado";

  const foto = pedido.fotos.find(
    (f) => f.i === foto_id && (f.cantidad || 0) > 0 // TODO: fix f.cantidad type
  );

  if (!foto) return "ERROR: la foto no existe";

  const url = fotoURL(foto, "big");
  const img = useQuery({
    queryKey: [url],
    queryFn: () => urlToDataUrl(url),
    throwOnError: true,
  });

  if (!img.data) return "Loading";

  return (
    <div style={{ textAlign: "center" }}>
      <PhotoEditor
        src={img.data}
        ops={
          foto.edicion
            ? EditorOpsZod.parse(JSON.parse(foto.edicion))
            : undefined
        }
        onSave={async (ops) => {
          if (
            (
              await POST("/pedido/:pedido_id/set_edicion/:foto_id", {
                p: { pedido_id, foto_id },
                b: { edicion: JSON.stringify(ops) },
              })
            ).status === "ok"
          ) {
            queryClient.invalidateQueries({
              queryKey: ["/appStatus.json"],
            });
            router.history.back();
          }
        }}
      />
    </div>
  );
}
